import React from "react";
import {
	NavArrow,
	NavCurrency,
	NavCurrencyItem,
	NavCurrencyModal,
	NavCurrencyModalSymbol,
	NavCurrencySymbol,
	NavLink,
	NavRegionCountriesList,
	NavRegionCountryItem,
	NavRegionFilter,
	NavRegionFlag,
	NavRegionInsideFlag,
	NavRegionMenuInput,
	NavRegionModal,
	NavRegionSearchIcon,
	NavRegionSearchNoResult,
	NavShipTo,
	NavShipToArrow,
	NavShipToModal,
	NavShipToModalTitle,
	NavShipToModule,
	NavShipToSaveButton,
	NavShipToSelection,
	NavShipToSelectionToggle,
	NavShipToSelectionToggleText,
	NavSlash,
} from "./styles";
import { Triangle, TriangleShadow } from "../../styles";
import getLangKeyValueFun from "../../../../../utils/lang";
import langGroup from "../../../../../assets/lang.json";
import { AssetImageUrl } from "../../../../../assets/imgUrl";
import { WebCountryFlagPosition } from "../../../../../utils/constant";
import Constant from "../../../../../utils/constant";

import setSession from "../../../../../headerServices/session";
import { lsGetItem, lsSetItem } from "../../../../../utils/safeWebStorage";
import { CountryInfo, CurrencyInfo } from "../../../../../headerServices/header/header";
import { replaceUrlParamVal } from "utils/url";

const getText = getLangKeyValueFun(langGroup);

interface ShipToProps {
	/** 非top，全部国家/地区 */
	countries: CountryInfo[];
	/** 根据接口返回的国家/地区中的分割线筛选出的置顶国家 */
	popularCounties: CountryInfo[];
	/** 用户当前国家/地区 */
	userCountry: CountryInfo;
	/** 全部货币 */
	currencies: CurrencyInfo[];
	/** 用户当前货币 */
	userCurrency: CurrencyInfo;
}

interface ShipToState {
	/** 是否展示下拉框 */
	showModal: boolean;
	/** 是否展示 Ship to 下拉框 */
	showRegionModal: boolean;
	/** 是否展示 Currency 下拉框 */
	showCurrencyModal: boolean;
	/** 当前选择的国家/地区 */
	newUserCountry: CountryInfo;
	/** 当前选择的货币 */
	newUserCurrency: CurrencyInfo;
	/** 搜索国家/地区的关键词 */
	searchText: string;
	allCountries: CountryInfo[];
	/** 最近选择过的国家/地区 */
	recentCountries: CountryInfo[];
}

class ShipTo extends React.Component<ShipToProps, ShipToState> {
	constructor(props) {
		super(props);
		const { countries = [], popularCounties = [], userCurrency = {} } = props;
		this.state = {
			showModal: false,
			showRegionModal: false,
			showCurrencyModal: false,
			newUserCountry: props.userCountry,
			newUserCurrency: userCurrency,
			searchText: "",
			allCountries: [...countries, ...popularCounties],
			recentCountries: [],
		};
	}

	componentDidMount() {
		window.addEventListener("click", () => {
			this.setState({
				showModal: false,
				showRegionModal: false,
				showCurrencyModal: false,
			});
		});
		// this.initialData();
	}

	componentDidUpdate(prevProps: ShipToProps) {
		const { userCountry, userCurrency } = this.props;
		if (prevProps.userCountry !== userCountry) {
			this.setState({
				newUserCountry: userCountry,
			});
		}
		if (prevProps.userCurrency !== userCurrency) {
			this.setState({
				newUserCurrency: userCurrency,
			});
		}
	}

	/** 获取旗帜定位 */
	getRegionFlagPosition = (regionISOCode: string) => {
		const isoCode = regionISOCode ? regionISOCode.toLocaleLowerCase() : "";
		return WebCountryFlagPosition[isoCode];
	};

	/** 是否打开下拉框 */
	onChangeModalStatus = (e: React.MouseEvent) => {
		const recentCountriesFromStorage = lsGetItem("RECENTCOUNTRIES") || "[]";
		e.stopPropagation();
		this.setState({
			showModal: !this.state.showModal,
			showRegionModal: false,
			showCurrencyModal: false,
			recentCountries: JSON.parse(recentCountriesFromStorage) || [],
		});
	};

	/** 是否点击下拉框内非选择区域 */
	onClickNonSelectionArea = (e: React.MouseEvent) => {
		e.stopPropagation();
		this.setState({
			showRegionModal: false,
			showCurrencyModal: false,
		});
	};

	/** 是否点击二级下拉框内非选择区域 */
	onClickNonSelectionSubArea = (e: React.MouseEvent) => {
		e.stopPropagation();
	};

	/** 是否打开国家/地区选择下拉框 */
	onChangeRegionModalStatus = (e: React.MouseEvent) => {
		e.stopPropagation();
		this.setState({
			showRegionModal: !this.state.showRegionModal,
			showCurrencyModal: false,
		});
	};

	/** 是否打开货币选择下拉框 */
	onChangeCurrencyModalStatus = (e: React.MouseEvent) => {
		e.stopPropagation();
		this.setState({
			showCurrencyModal: !this.state.showCurrencyModal,
			showRegionModal: false,
		});
	};

	/** 修改搜索内容 */
	onChangeSearchText = (e: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({
			searchText: e.target.value,
		});
	};

	/** 修改当前选择的国家/地区 */
	onChangeUserCountry = (newUserCountry: CountryInfo) => {
		const { currencies = [] } = this.props;
		const newUserCurrency = currencies.find(
			(cr) => cr.currency_code === newUserCountry.defaultCurrency,
		);
		this.setState({
			newUserCountry,
			newUserCurrency,
			showRegionModal: false,
		});
	};

	/** 修改当前选择的货币 */
	onChangeUserCurrency = (newUserCurrency: CurrencyInfo) => {
		this.setState({
			newUserCurrency,
			showCurrencyModal: false,
		});
	};

	/** 将选择的存在 LocalStorage */
	onSaveLocalStorage = () => {
		const { newUserCountry } = this.state;
		let localStorageList = [];
		try {
			localStorageList = JSON.parse(lsGetItem("RECENTCOUNTRIES")) || [];
		} catch (e) {
			localStorageList = [];
		}
		if (!localStorageList.some((i) => i.country_id === newUserCountry.countryId)) {
			localStorageList.unshift(newUserCountry);
			lsSetItem("RECENTCOUNTRIES", JSON.stringify(localStorageList));
		}
	};

	/** 保存已修改的内容 */
	onSave = async () => {
		const { newUserCountry, newUserCurrency } = this.state;
		this.onSaveLocalStorage();
		let url = window.location.href;
		if (newUserCountry?.countryIsoCode2) {
			Constant.countryCode2 = newUserCountry.countryIsoCode2;
			url = replaceUrlParamVal("country_code", newUserCountry?.countryIsoCode3);
		}

		if (newUserCurrency?.currency_code) {
			Constant.currency = newUserCurrency.currency_code;
			url = replaceUrlParamVal("currency", newUserCurrency.currency_code || "USD", url);
		}

		await setSession({
			countryCode: newUserCountry?.countryIsoCode2?.toLowerCase(),
			currencyCode: newUserCurrency?.currency_code,
		});
		location.replace(url);
	};

	render() {
		const { userCountry, currencies = [], userCurrency, countries = [] } = this.props;
		const {
			showModal,
			showRegionModal,
			showCurrencyModal,
			newUserCountry,
			newUserCurrency,
			searchText,
		} = this.state;
		const filterCountries = countries.filter(
			(i) => i.countryName.toLocaleLowerCase().indexOf(searchText.toLocaleLowerCase()) !== -1,
		);
		return (
			<NavShipToModule onClick={this.onChangeModalStatus}>
				<NavLink>
					<NavShipTo>{getText("Ship to")}:</NavShipTo>
					<NavRegionFlag
						style={{
							backgroundPosition: this.getRegionFlagPosition(
								userCountry?.countryIsoCode2,
							),
						}}
					/>
					<NavSlash>/</NavSlash>
					{userCurrency?.currency_symbol || "$"} {userCurrency?.currency_code}
					<NavArrow className={showModal && "isShow"} style={{ marginLeft: 5.5 }} />
				</NavLink>
				{showModal && (
					<NavShipToModal onClick={this.onClickNonSelectionArea}>
						<Triangle style={{ left: "41px" }} />
						<TriangleShadow style={{ left: "41px" }} />
						<NavShipToModalTitle>{getText("Ship to")}:</NavShipToModalTitle>
						<NavShipToSelection onClick={this.onChangeRegionModalStatus}>
							<NavShipToSelectionToggle>
								<NavRegionFlag
									style={{
										backgroundPosition: this.getRegionFlagPosition(
											newUserCountry?.countryIsoCode2,
										),
										margin: "2px 9px 1px 0px",
									}}
								/>
								<NavShipToSelectionToggleText>
									{newUserCountry?.countryName}
								</NavShipToSelectionToggleText>
								<NavShipToArrow className={showRegionModal && "open"} />
							</NavShipToSelectionToggle>
							{showRegionModal && (
								<NavRegionModal onClick={this.onClickNonSelectionSubArea}>
									<NavRegionFilter>
										<NavRegionSearchIcon
											src={AssetImageUrl["ic_search@3x.png"]}
										/>
										<NavRegionMenuInput
											value={searchText}
											onChange={this.onChangeSearchText}
											placeholder={getText("Search")}
										/>
									</NavRegionFilter>
									<NavRegionCountriesList>
										{!searchText &&
											countries.map((item) => (
												<NavRegionCountryItem
													key={item.countryId}
													onClick={() => this.onChangeUserCountry(item)}>
													<NavRegionInsideFlag
														style={{
															backgroundPosition:
																this.getRegionFlagPosition(
																	item?.countryIsoCode2,
																),
														}}
													/>
													<span>{item?.countryName}</span>
												</NavRegionCountryItem>
											))}
										{searchText &&
											0 in filterCountries &&
											filterCountries.map((item) => (
												<NavRegionCountryItem
													key={item.countryId}
													onClick={() => this.onChangeUserCountry(item)}>
													<NavRegionInsideFlag
														style={{
															backgroundPosition:
																this.getRegionFlagPosition(
																	item?.countryIsoCode2,
																),
														}}
													/>
													<span>{item.countryName}</span>
												</NavRegionCountryItem>
											))}
										{searchText && !(0 in filterCountries) && (
											<NavRegionSearchNoResult>
												{getText("No result match")}
												{`"${searchText}"`}
											</NavRegionSearchNoResult>
										)}
									</NavRegionCountriesList>
								</NavRegionModal>
							)}
						</NavShipToSelection>
						<NavShipToModalTitle>{getText("Currency")}:</NavShipToModalTitle>
						<NavShipToSelection onClick={this.onChangeCurrencyModalStatus}>
							<NavShipToSelectionToggle>
								<NavCurrencySymbol>
									{newUserCurrency?.currency_symbol}
								</NavCurrencySymbol>
								<NavShipToSelectionToggleText>
									{newUserCurrency?.currency_code}
								</NavShipToSelectionToggleText>
								<NavShipToArrow className={showCurrencyModal && "open"} />
							</NavShipToSelectionToggle>
							{showCurrencyModal && (
								<NavCurrencyModal onClick={this.onClickNonSelectionSubArea}>
									{currencies.map((item) => (
										<NavCurrencyItem key={item.sort_order}>
											<NavCurrency
												onClick={() => this.onChangeUserCurrency(item)}>
												<NavCurrencyModalSymbol>
													{item.currency_symbol} {""}
												</NavCurrencyModalSymbol>
												{item.currency_code}
											</NavCurrency>
										</NavCurrencyItem>
									))}
								</NavCurrencyModal>
							)}
						</NavShipToSelection>
						<NavShipToSaveButton onClick={this.onSave}>
							{getText("Save")}
						</NavShipToSaveButton>
					</NavShipToModal>
				)}
			</NavShipToModule>
		);
	}
}

export default ShipTo;
